<template>
  <div>
    <a-row :gutter="[16, 16]" class="mb-3">
      <a-col :xs="24" :md="10" :lg="8">
        <a-select
          v-model:value="selectedOrganization"
          :options="organizationOptions"
          :filter-option="filterOrganizationOption"
          placeholder="Select an organization"
          show-search
          allow-clear
          class="w-100"
        />
      </a-col>
      <a-col v-if="selectedOrganization" :xs="24" :md="8" :lg="6">
        <a-input
          v-model:value="featureSearch"
          placeholder="Search features"
          allow-clear
        />
      </a-col>
      <a-col v-if="selectedOrganization" class="d-flex align-items-center">
        <span class="text-secondary">
          {{ enabledCount }} of {{ sortedFeatures.length }} features enabled
        </span>
      </a-col>
    </a-row>

    <a-empty
      v-if="!selectedOrganization"
      description="Select an organization to see which features it has."
    />

    <a-list
      v-else
      bordered
      :data-source="visibleFeatures"
      :loading="isLoadingAdminFeatureControl && !adminFeatures.length"
      :pagination="
        visibleFeatures.length > pageSize ? { pageSize, size: 'small' } : false
      "
    >
      <template #renderItem="{ item }">
        <a-list-item>
          <a-list-item-meta :description="featureDescription(item)">
            <template #title>
              <span class="feature-name">{{ item.name }}</span>
              <a-tooltip
                v-if="item.suppressed"
                title="Nobody has this feature while it is disabled. Re-enable it in the By feature tab."
              >
                <a-tag color="red" class="ml-2">Disabled for everyone</a-tag>
              </a-tooltip>
            </template>
          </a-list-item-meta>
          <template #actions>
            <a-switch
              :checked="!!subscriptionFor(item)"
              :disabled="item.suppressed"
              :loading="!!busy[subscriptionKey(item.id, selectedOrganization)]"
              checked-children="On"
              un-checked-children="Off"
              @change="(checked) => handleToggle(item, checked)"
            />
          </template>
        </a-list-item>
      </template>
      <template #emptyText>
        <a-empty
          :description="
            adminFeatures.length
              ? 'No features match your search.'
              : 'No features yet. Use Add Feature to create one.'
          "
        />
      </template>
    </a-list>
  </div>
</template>

<script>
import featureControlMixin from './featureControlMixin';

export default {
  name: 'FeatureControlByOrganization',
  mixins: [featureControlMixin],
  data() {
    return {
      selectedOrganization: undefined,
      featureSearch: '',
      pageSize: 20,
    };
  },
  computed: {
    selectedOrganizationName() {
      const option = this.organizationOptions.find(
        (item) => item.value === this.selectedOrganization
      );
      return option?.label || this.selectedOrganization;
    },
    organizationSubscriptions() {
      return this.adminFeatureSubscriptions.filter(
        (item) => item.Organization?.Org_name === this.selectedOrganization
      );
    },
    enabledCount() {
      return this.sortedFeatures.filter((feature) =>
        this.subscriptionFor(feature)
      ).length;
    },
    visibleFeatures() {
      const search = this.featureSearch.trim().toLowerCase();
      if (!search) return this.sortedFeatures;
      return this.sortedFeatures.filter((feature) =>
        `${feature.name} ${this.featureDescription(feature)}`
          .toLowerCase()
          .includes(search)
      );
    },
  },
  methods: {
    subscriptionFor(feature) {
      return this.organizationSubscriptions.find(
        (item) => item.Feature?.id === feature.id
      );
    },
    handleToggle(feature, checked) {
      if (checked) {
        this.enableForOrganization(
          feature,
          this.selectedOrganization,
          this.selectedOrganizationName
        );
        return;
      }
      const subscription = this.subscriptionFor(feature);
      if (subscription) this.confirmRemoveAccess(subscription);
    },
  },
};
</script>

<style scoped>
.feature-name {
  font-weight: 600;
}
</style>
